// @flow
import {List} from 'immutable';
import {Store} from 'client/framework';
import {isResourcePopulated, getResourceMetadata, getResource} from 'resources/mandark.resource';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import appStore from 'client/AppStore';

import type {AssignmentModelV2} from 'resources/Assignment/V2/Assignment.model.js';

class AssignmentOverviewCompletionStore extends Store {
  constructor(name: string) {
    super(name);
    // not closing over the query proper because we need a new query if the route changes.
    this.getMeta = () => {
      return getResourceMetadata(this.getAssignmentQuery());
    };
  }

  getAssignmentQuery(): Object {
    return mandarkEndpoint(['students_v2', appStore.routerProps.params.userId, 'assignments_v2'])
      .filter({
        classrooms_v1: appStore.routerProps.params.classId
      })
      .customQuery({
        with_meta: 'assignment_v2'
      })
      .meta({
        context: {
          student: {
            id: appStore.routerProps.params.userId
          }
        }
      })
      .done();
  }

  hasAssignmentData(): boolean {
    return isResourcePopulated(this.getAssignmentQuery());
  }

  getAssignmentData(): List<AssignmentModelV2> {
    return getResource(this.getAssignmentQuery());
  }

  getSubmittedNumber(): number {
    const totalSubmitted = this.getMeta().getIn(['request', 'complete', 'total']);
    const submittedOnTime = totalSubmitted - this.getLateSubmittedNumber();
    return submittedOnTime;
  }

  getLateSubmittedNumber(): number {
    const lateSubmitted = this.getMeta().getIn(['request', 'complete', 'late']);
    return lateSubmitted;
  }

  getNotSubmittedNumber(): number {
    const unsubmitted = this.getMeta().getIn(['request', 'incomplete', 'total']);
    return unsubmitted;
  }

  getLateNotSubmittedNumber(): number {
    const lateUnsubmitted = this.getMeta().getIn(['request', 'incomplete', 'late']);
    return lateUnsubmitted;
  }

  getPastDueNumber(): number {
    // This assignment list is filtered by due_date < now()
    return this.getAssignmentData().size;
  }

  getTotalAssignments(): number {
    return this.getMeta().getIn(['page', 'total_entries']);
  }
}

export default new AssignmentOverviewCompletionStore('AssignmentOverviewCompletionStore');
